/**
 * AlphaSense Agent - Suggestions Section
 * Section 3: Suggestions for best performance
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { ALPHASENSE_PROMPT_KEYS } from './variables';
class AlphaSenseSuggestionsSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = ALPHASENSE_PROMPT_KEYS.suggestions;
        this.fallbackContent = `## Best Practices

### Query Formulation
- Submit ALL queries in ONE batch call when possible
- Use specific company names and time periods
- Be precise with financial metrics (e.g., "Q4 2024 revenue" not just "revenue")
- Include relevant context (industry, comparison companies)

### Result Selection
- Include all relevant chunk IDs - better to include more than miss important data
- Prioritize primary sources (earnings calls, SEC filings) over secondary analysis
- When multiple chunks cover the same topic, include the most comprehensive one

### Rationale Writing
- Write detailed rationales explaining what you found
- Link specific findings to the requirement
- Note any limitations or gaps in the data found

### Efficiency Tips
- Batch related queries together
- Use use_findata_agent=true for quantitative data queries
- Avoid redundant searches for the same information`;
    }
}
const suggestionsSection = new AlphaSenseSuggestionsSection();
/**
 * Get the suggestions section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getSuggestionsSection() {
    return suggestionsSection.getContent();
}
/**
 * Export constant for backwards compatibility
 */
export const ALPHASENSE_SUGGESTIONS = suggestionsSection.getFallbackContent();
